import { ChangeEvent, FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Input } from 'src/components/common/Input';
import { useConnectedAction } from 'src/hooks/use-connected-action';
import { useResetSignUpError } from 'src/hooks/useResetSignupErrors';
import { setError } from 'src/store/user/actions';
import { RootState } from 'src/types/store-types';
import * as Yup from 'yup';

type IProps = {
  name: string;
  value: string;
  regexp: string;
  onChange: (e: any) => void;
  placeholder?: string;
  required?: boolean;
};
const FirstName_Input: FC<IProps> = (props) => {
  // Hooks
  const { t }: Translation = useTranslation();

  // Redux
  const _setErrorReq = useConnectedAction(setError);
  const resetSignUpError = useResetSignUpError();

  // Selectors
  const { errors: signUpErrors, dniResult } = useSelector((state: RootState) => state.user);
  const { firstname, lastname } = dniResult || {};
  // YUP Validation
  const validationSchema = Yup.object().shape({
    firstname: Yup.string()
      .required(t('requiredField'))
      .matches(new RegExp(props.regexp), t('fieldLength', { count: '2-20' })),
  });

  const handleValidate = async (value: string): Promise<void> => {
    try {
      await validationSchema.validate({ firstname: value }, { abortEarly: false });
      resetSignUpError('firstname');
    } catch (error: any) {
      if (error.name === 'ValidationError') {
        _setErrorReq({ ...signUpErrors, firstname: error.errors[0] });
      }
    }
  };

  useEffect(() => {
    if (Object.keys(dniResult).length) {
      props.onChange({
        target: {
          name: props.name,
          value: `${firstname} ${lastname}`,
        },
      });
      handleValidate(`${firstname} ${lastname}`);
    }
  }, [dniResult]);

  // Actions
  const handleOnChange = (e: ChangeEvent<HTMLInputElement>): void => {
    if (signUpErrors.firstname) {
      resetSignUpError('firstname');
    }
    props.onChange(e);
  };

  const handleBlur = (): void => {
    handleValidate(props.value?.trim());
  };

  return <Input error={signUpErrors.firstname} {...props} onChange={handleOnChange} onBlur={handleBlur} />;
};
export default FirstName_Input;
